import { render } from "./SkillsComponent.vue?vue&type=template&id=396e0c4a&ts=true"
import script from "./SkillsComponent.vue?vue&type=script&lang=ts"
export * from "./SkillsComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__